
<div class="panels">
  <PanelItem
    v-for="p in periods"
    :key="p"
    :content="content"
    :period="p"
    :category="category"
    :is-open="currentPeriod === p"
    @toggle="$emit('select', p)"
  />
</div>
